import { gql } from "@apollo/client";

export const IMPORT_PRODUCTS_SUMMARY_FRAGMENT = gql`
  fragment ImportSummaryFragment on ImportProductsFromCsvResult {
    importedProducts
    importedProductVariants
    processedProducts
    processedProductVariants
    failedAssets
    error
  }
`;

export const IMPORT_PRODUCTS_FROM_CSV = gql`
  mutation ImportProductsFromCsv($file: Upload!) {
    importProductsFromCsv(file: $file) {
      ...ImportSummaryFragment
    }
  }
  ${IMPORT_PRODUCTS_SUMMARY_FRAGMENT}
`;


export const EXPORT_PRODUCTS_TO_CSV = gql`
  mutation ExportProductsToCsv($input: ExportProductInput!) {
    exportProductsToCsv(input: $input) {
      downloadURL
      error
    }
  }
`;

export const PRODUCT_EXPORT_CSV_TEMPLATE_DOWNLOAD_URL = gql`
  query ProductExportCsvTemplateDownloadUrl {
    productExportCsvTemplateDownloadUrl {
      downloadURL
      error
    }
  }
`;

export const GENERATE_PRODUCT_REVIEWS_TO_CSV = gql`
  mutation GenProductReviewsCsvTemplate($input: ExportProductInput!) {
    genProductReviewsCsvTemplate(input: $input) {
      downloadURL
      error
    }
  }
`;

export const IMPORT_PRODUCT_REVIEWS_FROM_CSV = gql`
  mutation ImportProductReviewsFromCsv($file: Upload!) {
    importProductReviewsFromCsv(file: $file) {
      importedProductReviews
      error
    }
  }
`;

export const EXPORT_ORDERS_TO_CSV = gql`
  mutation ExportOrdersToCsv($input: ExportOrderInput!) {
    exportOrdersToCsv(input: $input) {
      downloadURL
      error
    }
  }
`;

export const IMPORT_ORDER_FULFILLMENTS_FRAGMENT = gql`
  fragment ImportOrderFulfillmentsFragment on ImportOrderFulfillmentsFromCsvResult {
    importedItems
    error
  }
`;

export const IMPORT_ORDER_FULFILLMENTS_FROM_CSV = gql`
  mutation ImportOrderFulfillmentsFromCsv($file: Upload!) {
    importOrderFulfillmentsFromCsv(file: $file) {
      ...ImportOrderFulfillmentsFragment
    }
  }
  ${IMPORT_ORDER_FULFILLMENTS_FRAGMENT}
`;